
import React, { useState, useRef, useEffect } from 'react';
import './Header.css';
import { useAppState } from '../../context/AppStateContext';
import SilverIcon from '../shared/SilverIcon';

interface Props {
  onCommandPalette: () => void;
  mobile: boolean;
}

export default function Header({ onCommandPalette, mobile }: Props) {
  const { appState, setAppState } = useAppState();
  const [avatarOpen, setAvatarOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setAvatarOpen(false);
      }
    };
    if (avatarOpen) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [avatarOpen]);

  return (
    <header className="app-header">
      <div className="app-header__left">
        {!mobile && (
          <button
            className="app-header__collapse-btn"
            onClick={() => setAppState(s => ({ ...s, sidebarCollapsed: !s.sidebarCollapsed }))}
            title="Toggle sidebar"
          >
            <SilverIcon name="menu" size={18} />
          </button>
        )}
        <div className="app-header__logo">
          <div className="app-header__logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
              <path d="M12 2l1.2 4.2L17 7.5l-3.8 1.3L12 13l-1.2-4.2L7 7.5l3.8-1.3L12 2z"/>
            </svg>
          </div>
          <span className="app-header__logo-text">Super Dashboard</span>
        </div>
      </div>

      {!mobile && (
        <button className="app-header__search" onClick={onCommandPalette}>
          <SilverIcon name="search" size={15} style={{ color: 'var(--color-muted)' }} />
          <span className="app-header__search-placeholder">Search or run commands…</span>
          <kbd>⌘K</kbd>
        </button>
      )}

      <div className="app-header__right">
        {mobile && (
          <button className="app-header__icon-btn" onClick={onCommandPalette} title="Search">
            <SilverIcon name="search" size={18} />
          </button>
        )}
        <button className="app-header__icon-btn app-header__notif" title="Notifications">
          <SilverIcon name="bell" size={18} />
          {appState.notifications > 0 && (
            <span className="app-header__badge">{appState.notifications}</span>
          )}
        </button>
        <div className="app-header__avatar-wrap" ref={menuRef}>
          <button
            className="app-header__avatar"
            onClick={() => setAvatarOpen(o => !o)}
          >
            <span>JD</span>
          </button>
          {avatarOpen && (
            <div className="app-header__avatar-menu">
              <div className="avatar-menu__user">
                <strong>Jane Doe</strong>
                <span>jane@superdash.io</span>
              </div>
              <div className="avatar-menu__divider" />
              <button className="avatar-menu__item" onClick={() => setAvatarOpen(false)}>Profile</button>
              <button className="avatar-menu__item" onClick={() => setAvatarOpen(false)}>Settings</button>
              <button className="avatar-menu__item" onClick={() => setAvatarOpen(false)}>Billing Plan</button>
              <button className="avatar-menu__item" onClick={() => setAvatarOpen(false)}>API Keys</button>
              <button className="avatar-menu__item" onClick={() => setAvatarOpen(false)}>Keyboard Shortcuts</button>
              <div className="avatar-menu__divider" />
              <button className="avatar-menu__item avatar-menu__item--danger" onClick={() => setAvatarOpen(false)}>Sign Out</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
